// IVIPBanner.jsx
import React from "react";
import styles from "./styles.module.scss";

const IVIPBanner = () => {
  return (
    <div className={styles.ivipBanner}>
      <div className={styles.ivipBannerTrack}>
        <span key="ivip-banner__text" className={styles.ivipBannerText}>
          iVIP Customer
        </span>
      </div>
    </div>
  );
};

export default IVIPBanner;
